import { useState } from "react";
import { Plus, CornerDownLeft } from "lucide-react";

export const QuickAdd = ({ b }) => {
  const [title, setTitle] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const t = title.trim();
    if (!t) return;
    b.addGoal({ title: t });
    setTitle("");
  };
  return (
    <li className="py-4 px-2 sm:px-4 -mx-2 sm:-mx-4" data-testid="life-quick-add">
      <form onSubmit={submit} className="flex items-center gap-4">
        <span className="w-8 shrink-0 text-rose-300/50"><Plus size={16} /></span>
        <input value={title} onChange={(e) => setTitle(e.target.value)} maxLength={200}
          placeholder="Add a dream…" className="flex-1 bg-transparent outline-none font-display text-xl sm:text-2xl placeholder:text-slate-600 text-slate-100"
          data-testid="life-quick-add-input" />
        {title.trim() && (
          <button type="submit" className="flex items-center gap-1.5 font-mono text-[11px] text-rose-300 hover:text-rose-200 transition-colors" data-testid="life-quick-add-submit">
            <CornerDownLeft size={13} /> Enter
          </button>
        )}
      </form>
    </li>
  );
};
